import { InfoApiService } from './InfoApiService.js';

export const $api = {
    info: new InfoApiService(),
};